import React, { Component } from "react";
import { CallAPI, GetCookieFunction } from '../../utils/util';

class ScheduleConflicts extends Component {
    constructor(props) {
        super(props);
        this.centerId = GetCookieFunction("Center").id;
        this.state = {
            conflicts: [],
            loading: true,
            confirmCancelId: null
        };
    }

    componentDidMount() {
        this.loadConflicts();
    }

    loadConflicts = () => {
        CallAPI({}, `scheduling/conflicts?centerId=${this.centerId}`, 'GET', (res) => {
            if (res.success) {
                // For each conflict, load the patient list
                const conflicts = res.data;
                if (conflicts.length === 0) {
                    this.setState({ conflicts: [], loading: false });
                    return;
                }

                let loaded = 0;
                conflicts.forEach((conflict, idx) => {
                    const dateStr = conflict.scheduleDate ? conflict.scheduleDate.split('T')[0] : '';
                    CallAPI({}, `scheduling/daily?centerId=${this.centerId}&date=${dateStr}`, 'GET', (dayRes) => {
                        if (dayRes.success) {
                            const slotData = dayRes.data.find(s => s.slotId === conflict.slotId);
                            conflicts[idx].patients = slotData ? slotData.patients : [];
                        }
                        loaded++;
                        if (loaded === conflicts.length) {
                            this.setState({ conflicts, loading: false });
                        }
                    }, () => {
                        loaded++;
                        if (loaded === conflicts.length) {
                            this.setState({ conflicts, loading: false });
                        }
                    });
                });
            } else {
                this.setState({ loading: false });
            }
        }, () => this.setState({ loading: false }));
    }

    handleCancel = (scheduleId) => {
        this.setState({ confirmCancelId: scheduleId });
    }

    confirmCancel = () => {
        const scheduleId = this.state.confirmCancelId;
        this.setState({ confirmCancelId: null });
        CallAPI({}, `scheduling/book/${scheduleId}?centerId=${this.centerId}`, 'DELETE', (res) => {
            if (res.success) this.loadConflicts();
        });
    }

    formatTime = (timeStr) => {
        if (!timeStr) return "";
        const [h, m] = timeStr.split(":");
        const hour = parseInt(h, 10);
        const ampm = hour >= 12 ? "PM" : "AM";
        const h12 = hour % 12 || 12;
        return `${h12}:${m} ${ampm}`;
    }

    formatDate = (dateStr) => {
        if (!dateStr) return "";
        const parts = dateStr.substring(0, 10).split('-');
        const d = new Date(parts[0], parts[1]-1, parts[2]);
        return d.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' });
    }

    render() {
        const { conflicts } = this.state;

        return (
            <div className="ci-page" style={{maxWidth: '900px'}}>
                <div className="ci-header">
                    <h2>Scheduling Conflicts</h2>
                    <p>Slots where bookings exceed available machines</p>
                </div>

                {this.state.loading ? (
                    <div style={{textAlign: 'center', padding: '40px', color: 'var(--text-muted)'}}>Loading...</div>
                ) : conflicts.length === 0 ? (
                    <div className="ci-card" style={{textAlign: 'center', padding: '40px'}}>
                        <div style={{fontSize: '32px', marginBottom: '12px'}}>✅</div>
                        <p style={{fontSize: '16px', fontWeight: 600, color: 'var(--success)'}}>No scheduling conflicts</p>
                        <p style={{fontSize: '13px', color: 'var(--text-muted)'}}>All slots are within capacity.</p>
                    </div>
                ) : (
                    <div className="daily-schedule-slots">
                        {conflicts.map((conflict, idx) => {
                            const over = conflict.booked - conflict.availableMachines;
                            return (
                                <div key={idx} className="daily-schedule-slot">
                                    <div className="daily-schedule-slot-header overbooked">
                                        <div>
                                            <div className="daily-schedule-slot-time">
                                                {this.formatDate(conflict.scheduleDate)}
                                            </div>
                                            <div style={{fontSize: '12px', marginTop: '2px'}}>
                                                {this.formatTime(conflict.startTime)} – {this.formatTime(conflict.endTime)}
                                            </div>
                                        </div>
                                        <span className="daily-schedule-slot-count" style={{color: 'var(--danger)', fontWeight: 700}}>
                                            {conflict.booked}/{conflict.availableMachines} ({over} over)
                                        </span>
                                    </div>
                                    <div className="daily-schedule-patients">
                                        {(conflict.patients || []).map(p => (
                                            <div key={p.scheduleId} className="daily-schedule-patient">
                                                <a href={`/patients/${p.patientId}/profile`} style={{color: 'var(--primary)', textDecoration: 'none', flex: 1, fontWeight: 500}}>
                                                    {p.firstName} {p.lastName}
                                                </a>
                                                {p.patientCode && <span className="daily-schedule-code">{p.patientCode}</span>}
                                                <button type="button" className="editable-delete-btn"
                                                    onClick={() => this.handleCancel(p.scheduleId)}>✕</button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                {/* Cancel Confirmation Modal */}
                {this.state.confirmCancelId && (
                    <div className="ci-modal-overlay" onClick={() => this.setState({ confirmCancelId: null })}>
                        <div className="ci-modal" onClick={(e) => e.stopPropagation()}>
                            <h3>Cancel Appointment</h3>
                            <p style={{fontSize: '14px', color: 'var(--text-secondary)', margin: '12px 0'}}>
                                Cancel this appointment to resolve the conflict? The slot will be released.
                            </p>
                            <div className="ci-submit-row">
                                <button type="button" className="homeButton" onClick={() => this.setState({ confirmCancelId: null })}>Keep</button>
                                <button type="button" className="logSubmit" style={{width: 'auto', background: 'var(--danger)'}} onClick={this.confirmCancel}>Cancel Appointment</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default ScheduleConflicts;
